import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonRounded from '../../forms/buttons/ButtonRounded';

export default class ListPageHeader extends PureComponent {
  render () {
    return (
      <div className='top-header'>
        <div className='page-title'>
          <div className='title-icon'>
            <FontAwesomeIcon icon={this.props.icon} size='lg' />
          </div>

          <h1 className='h3 mb-0'>{this.props.title}</h1>

          {this.props.onClick && <ButtonRounded onClick={this.props.onClick} className='ml-4 mr-auto' />}
        </div>
      </div>
    );
  }
}

ListPageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  onClick: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/common/lists/ListPageHeader/index.js